import { __rest } from '../../_virtual/_tslib.js';
import React__default, { useContext } from 'react';
import classNames from 'classnames';
import Collapse from 'reactstrap/lib/Collapse';
import { AppContext } from '../../app-context.js';
import faqQuestionStyle from './FaqQuestions.module.scss.js';
import { ReactComponent as SvgAngleRightGray } from '../../icons/AngleRightGray.svg.js';
import { ComponentState } from '../../constants/misc.js';
import Skeleton from '../skeleton/Skeleton.js';
import A from '../app-anchor/A.js';

const FaqQuestions = (_a) => {
    var _b;
    var { state = ComponentState.NORMAL } = _a, props = __rest(_a, ["state"]);
    const { data, index, handleClick, isOpen } = props;
    const { isMobile } = useContext(AppContext);
    if (state === ComponentState.NORMAL) {
        return (React__default.createElement("div", { className: classNames(faqQuestionStyle.question_layout) },
            React__default.createElement("div", { className: classNames(faqQuestionStyle.question, faqQuestionStyle.collapsible), onClick: () => handleClick({ currentFaqIndex: index, isOpen: !isOpen }), key: index },
                React__default.createElement("h3", { className: classNames(faqQuestionStyle.ques) },
                    !isMobile ? React__default.createElement("span", null, index + 1) : "",
                    " ",
                    data.question),
                React__default.createElement("div", { className: classNames(faqQuestionStyle.collapse_icon) }, !isOpen ? (React__default.createElement("span", { className: faqQuestionStyle.arrowDown },
                    React__default.createElement(SvgAngleRightGray, null))) : (React__default.createElement("span", { className: faqQuestionStyle.arrowTop },
                    React__default.createElement(SvgAngleRightGray, { className: classNames(faqQuestionStyle.collapse_icon_minus) }))))),
            React__default.createElement(Collapse, { isOpen: isOpen },
                React__default.createElement("div", { className: classNames(faqQuestionStyle.answer) },
                    data.response ? (React__default.createElement("p", null,
                        data.response,
                        data.link && React__default.createElement(A, { href: data.link }, " here."))) : (""),
                    data.subContent ? (React__default.createElement("ul", null, (_b = data.subContent) === null || _b === void 0 ? void 0 : _b.map((content, index) => (React__default.createElement("li", { key: index },
                        " ",
                        React__default.createElement("div", { dangerouslySetInnerHTML: { __html: content } })))))) : ("")))));
    }
    else {
        return (React__default.createElement("div", { className: classNames(faqQuestionStyle.question_layout) },
            React__default.createElement("div", { className: classNames(faqQuestionStyle.question, faqQuestionStyle.collapsible) },
                React__default.createElement("h3", { className: classNames(faqQuestionStyle.ques) },
                    React__default.createElement(Skeleton, null)),
                React__default.createElement(Skeleton, null))));
    }
};

export { FaqQuestions as default };
//# sourceMappingURL=FaqQuestions.js.map
